export default __webpack_public_path__ + "static/media/backLeft.81dc0d98.svg";